// extracted by mini-css-extract-plugin
module.exports = {"fake":"index_fake__1upX0eGF"};